// プランナーの基本情報の見出し。詳細・メッセージ詳細・オファー／メッセージ一覧カードで同じ文言を使う（Trello #245）。
export const PLANNER_SUPPORTED_TYPES_LABEL = "対応可能種別";
export const PLANNER_STRENGTHS_LABEL = "得意な領域";
